import React, { useState } from 'react'
import { TabPane } from 'reactstrap';
import { Heading } from './components/Heading';
import * as actionTypes from "../../store/Actions/actions";
import { useDispatch, useSelector } from 'react-redux';

export const TabFeatures = () => {
    const { navigationAlign, navigationSearch, hamburgerMenu } = useSelector(state => state.present);
    const dispatch = useDispatch();
    const [labelError, setLabelError] = useState(false);

    const navigationSearchEnable = (value) => {
        dispatch(actionTypes.navigation_search(value.target.checked))
    };

    const hamburgerMenuEnable = (value) => {
        dispatch(actionTypes.hamburger_menu(value.target.checked))
    };

    const extractContent = (s) => {
        var span = document.createElement("span");
        span.innerHTML = s;
        return span.textContent || span.innerText;
    };

    const handleNavigationAlign = (e) => {
        dispatch(actionTypes.navigation_align(e.target.value));
    };

    return (
        <TabPane tabId="2">
            <Heading title="Header Features" />
            <div className="modalContentWrapper">
                <div className="addPage">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            alignContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                        className="col-4"
                    >
                        <label style={{ textAlign: "center" }}>
                            Search Option
                        </label>
                        <input
                            onChange={navigationSearchEnable}
                            type="checkbox"
                            checked={navigationSearch ? "checked" : ""}
                        />
                    </div>
                    <div
                        className="col-4"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            alignContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                    >
                        <label style={{ textAlign: "center" }}>
                           Desktop Hamburger Menu
                        </label>
                        <input
                            onChange={hamburgerMenuEnable}
                            type="checkbox"
                            id="hamburger"
                            checked={hamburgerMenu.menu ? "checked" : ""}
                        />

                        {hamburgerMenu.menu && (
                            <div>
                                <div>
                                    <span className="menuTitleHamburger">
                                        Hamburger Title
                                    </span>
                                    <div className="labelInputText">
                                        <input
                                            style={{
                                                backgroundColor: "transparent",
                                                border: "0px",
                                            }}
                                            placeholder="Add label"
                                            value={hamburgerMenu.label}
                                            onChange={(e) => {
                                                let value = e.target.value;
                                                if (
                                                    extractContent(e.target.value)
                                                        .length < 32
                                                ) {
                                                    setLabelError(false);
                                                    dispatch(actionTypes.hamburger_menu_label(value))
                                                } else {
                                                    setLabelError(true);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                {labelError && (
                                    <small
                                        style={{
                                            marginTop: "3px",
                                            color: "red",
                                            float: "left",
                                            fontSize: "10px",
                                        }}
                                    >
                                        The maximum length of label should be less
                                        than 32 characters.
                                    </small>
                                )}
                            </div>
                        )}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            justifyItems: "center",
                            alignContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                        }}
                        className="col-4"
                    >
                        <label style={{ textAlign: "center" }}>
                            Navigation Align
                        </label>
                        <select
                            value={navigationAlign || "right"}
                            onChange={handleNavigationAlign}
                        >
                            <option value="right">Right</option>
                            <option value="center">Center</option>
                            <option value="left">Left</option>
                        </select>
                    </div>
                </div>
            </div>
        </TabPane>
    )
}
